import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShower = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		style: {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: "1.5px"
		},
		children: [
			/* @__PURE__ */ _jsx("rect", {
				x: 3,
				y: 3,
				width: 18,
				height: 18,
				rx: 1
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 12,
				cy: 12,
				r: 2.2
			}),
			/* @__PURE__ */ _jsx("line", {
				x1: 4.2,
				y1: 4.2,
				x2: 10.2,
				y2: 10.2
			}),
			/* @__PURE__ */ _jsx("line", {
				x1: 19.8,
				y1: 4.2,
				x2: 13.8,
				y2: 10.2
			}),
			/* @__PURE__ */ _jsx("line", {
				x1: 4.2,
				y1: 19.8,
				x2: 10.2,
				y2: 13.8
			}),
			/* @__PURE__ */ _jsx("line", {
				x1: 19.8,
				y1: 19.8,
				x2: 13.8,
				y2: 13.8
			})
		]
	})
});
export default SvgShower;
